// extracted by mini-css-extract-plugin
export var attachButton = "_e6-8";
export var sendButton = "_e6-2";
export var sendDisabled = "_e6-4";
export var sendEnabled = "_e6-3";
export var sendIcon = "_e6-6";
export var sendIconDisabled = "_e6-7";
export var sendStreaming = "_e6-5";
export var textarea = "_e6-1";
export var wrapper = "_e6-0";